import {Component, OnInit, ViewChild, HostListener, ElementRef} from '@angular/core';
import {SharedService} from '../../services/shared.service';
import {HttpApiService} from '../../services/http-api.service';
import {EndpointsService} from '../../services/endpoints.service';
import {Constants} from '../../services/constants';
import {ProfilesService} from '../../services/profiles.service';
import {Router, ActivatedRoute} from '@angular/router';
import {SearchProfileService} from '../../services/search-profile.service';
import {ModalDirective} from 'ngx-bootstrap'
import {UserService} from '../../services/user.service';
import {AlertMessageComponent, AlertType} from '../../shared/alert-message/alert-message.component';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {URLSearchParams} from '@angular/http';
import {el} from '@angular/platform-browser/testing/src/browser_util';
import {forEach} from "@angular/router/src/utils/collection";
import {TenantService} from '../../services/tenant.service';

declare var jQuery: any;


@Component({
  selector: 'app-app-profile',
  templateUrl: './app-profile.component.html',
  styleUrls: ['./app-profile.component.scss']
})
export class AppProfileComponent implements OnInit {
  profile: any = {
    addons: [], details: {
      technicalInfo: {hostingProvider: {}},
      licensingTerms: {}, testimonials: [], awards: [], videos: [],
      screenshots: [], resellerProgram: {}, features: [],
      benefits: [], pricingPlans: [], support: {}, resellerSupport: {}
    }, socialMedia: {}
  };
  subject = 'meeting';
  requestMeeting = '';
  pricingPlans: any;
  selectedResellerPrograms: Array<string>;
  selectedAppTypes: Array<string>;
  searchQuery: string;
  @ViewChild('modal') public modal: ModalDirective;
  @ViewChild('supportModel') public supportModel: ModalDirective;
  @ViewChild('resellerVideoModal') public resellerVideoModal: ModalDirective;
  @ViewChild('resellerAlertModal') public resellerAlertModal: ModalDirective;
  @ViewChild('resellerProgramModal') public resellerProgramModal: ModalDirective;
  @ViewChild('tooltipModal') public tooltipModal: ModalDirective;
  isMothershipTenant: boolean = Constants.IS_MOTHERSHIP_TENANT();
  pageYOffset: number;
  reseller: any = {};
  selectedResellerOption: string;
  showResellerVideo: boolean;
  retailCom: boolean;
  shareUrl: string;
  isAddedToFavorites: boolean;
  resellerProgram: any = {RetailCommission: false, WholesaleCommission: false, Affiliate: false, WhiteLabel: false};
  checkResellerProgram: any = {RetailCommission: true, WholesaleCommission: false, Affiliate: false, WhiteLabel: false};
  showForm = false;
  eSignUrl = '';
  trustedESignUrl: SafeResourceUrl;
  private tenantBucket = Constants.TENANT_BUCKET();
  private categories: any;
  private selectedPricingPlans: any = {};
  showResellerProgram: boolean;
  isPricingPlanAvailable = null;
  isContactVendorDisplay = false;
  affiliateStatus: string = '';
  retailCommissionStatus: string = '';
  whiteLabelStatus: string = '';
  wholesaleCommissionStatus: string = '';
  isRetailDistable: boolean;
  isWhitelabelDisable: boolean;
  isAffiliateDisable: boolean;
  isWholesaleDisable: boolean;
  affiliateType: string = '';
  retailCommissionType: string = '';
  whiteLabelType: string = '';
  wholesaleCommissionType: string = '';


  affiliateTemplateId: string = '';
  retailCommissionTemplateId: string = '';
  whiteLabelTemplateId: string = '';
  wholesaleCommissionTemplateId: string = '';

  affiliateContractUrl: string = '';
  retailCommissionContractUrl: string = '';
  whiteLabelContractUrl: string = '';
  wholesaleCommissionContractUrl: string = '';

  trustedAffiliateContractUrl: SafeResourceUrl;
  trustedRetailCommissionContractUrl: SafeResourceUrl;
  trustedWhiteLabelContractUrl: SafeResourceUrl;
  trustedWholesaleCommissionContractUrl: SafeResourceUrl;
  currentUser: any = {};
  textMaxLenght = 230;
  isApprovedReseller = false;
  isBrochureAvailable = false;
  isTestimonialAvailable = false;
  isScreenShotAvailable = false;
  isVideoAvailable = false;
  isAwardAvailable = false;
  isPricingAmountAvailable = false;
  textMaxLenght1 = 230;
  textMaxLenght2 = 230;
  textMaxLenght3 = 230;
  textMaxLenght4 = 230;
  textMaxLenght5 = 230;
  textMaxLenght6 = 230;
  textMaxLenght7 = 156;
  textMaxLenght8 = 230;
  approvalRequested = false;
  errorMessage = '';
  successMessage = '';
  isUpdating = false;
  tenant;
  resellerProgramRequestList = {}
  private tawk_to = Constants.TAWK_TO();

  constructor(private sharedService: SharedService,
              private api: HttpApiService,
              private profileService: ProfilesService,
              private endpoints: EndpointsService,
              private userService: UserService,
              private searchService: SearchProfileService,
              private route: ActivatedRoute,
              private router: Router,
              private sanitizer: DomSanitizer,
              private activatedRoute: ActivatedRoute,
              private tenantService: TenantService) {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.pageYOffset = window.pageYOffset;
  };

  ngOnInit() {
    const tenantUser = this;
    tenantUser.tenantService.getTenantWithPromise().then((response) => {
      tenantUser.tenant = response;
    });
    let profileId;
    this.route.params
      .subscribe(data => {
        profileId = decodeURIComponent(this.sharedService.decodeBase64(data['id']));
      });
    this.getCurrentUser();
    if (profileId) {
      const params = new URLSearchParams();
      params.set('isContactVendorDisplay', 'true');
      this.isUpdating = true;
      const isLoggedInStatus = this.isLoggedIn() ? true : false;
      this.api.get(this.endpoints.getProfileUrl() + '/' + profileId + '?domain=' + Constants.TENANT_ID())
        .subscribe(profile => {
          this.profile = profile;
          this.profile.details.resellerSupport = this.profile.details.resellerSupport || {};
          this.isCurrentApprovedReseller(this.profile);
          this.api.get(this.endpoints.getProfileUrl() + '/' + profileId + '?isContactVendorDisplay=true&domain=' +
            Constants.TENANT_ID() + '&profileId=' + profileId, isLoggedInStatus)
            .subscribe(res => {
              this.isContactVendorDisplay = res;
            });
          this.setShareUrl();
          this.profile.details.pricingPlans = this.profile.details.pricingPlans.filter(item => item.status == 'Published');
          this.isPricingPlanAvailable = this.isPricingAvailable(this.profile);
          this.getResellerProgramType();
          this.isUpdating = false;
        });
      this.profileService.incrementProfileViews(profileId);
      if (this.isLoggedIn() && this.isBuyer()) {
        this.api.get(this.endpoints.getIsBookmarkedUrl() + '?profileId=' + profileId, true)
          .subscribe((response: any) => {
            this.isAddedToFavorites = response.isBookmarked;
          });
      }
    }
    const self = this;
    this.profileService.subscribeForCategories()
      .subscribe(categories => {
        this.categories = [];
        categories.forEach(function (item) {
          self.categories.push(item);
          item.subCategories.forEach(function (item1) {
            item1.isSubCategory = true;
            self.categories.push(item1);
          });
        });
      });
    this.profileService.getCategories();
    this.selectedResellerPrograms = this.searchService.getParameter('selectedResellerPrograms');
    this.selectedAppTypes = this.searchService.getParameter('selectedAppTypes');
    this.searchQuery = this.searchService.getParameter('searchQuery');
    if (this.selectedResellerPrograms && this.selectedResellerPrograms.length == 0) {
      this.selectedResellerPrograms = null;
    }
    if (this.selectedAppTypes && this.selectedAppTypes.length == 0) {
      this.selectedAppTypes = null;
    }
    this.api.get(this.endpoints.getResellerByDomainUrl(`domain=${Constants.TENANT_ID()}`))
      .subscribe(response => {
          this.reseller = response;
        },
        error => {
          // console.log(error);
        });
    this.resellerProgramModal.onHidden.subscribe(() => {
      this.showResellerProgram = false;
    });
    this.getResellerProgramStatus(profileId)
    this.activatedRoute.queryParams.subscribe(params => {
      setTimeout(() => {
        if (params.myCatalog && this.isReseller()) {
          this.showModal();
        } else {
          //this.showResellerAlertModal()
        }
      }, 100);
    });
    console.log("company name: "+this.reseller.companyName);
  }

  isCurrentApprovedReseller(profile) {
    if (this.isReseller()) {
      this.api.get(this.endpoints.getApprovedReseller() + '?vendorId=' + this.profile.appVendor.id + '&resellerId=this.currentUser.orgId',
        true)
        .subscribe(response => {
          this.isApprovedReseller = true;
          this.isAvailable(profile);
        }, error => {
          this.isApprovedReseller = false;
          this.isAvailable(profile);
        });
    }else {
      this.isAvailable(profile);
    }
  }

  isAvailable(profile) {
    for (const testimonial of profile.details.testimonials) {
      if (!this.isTestimonialAvailable) {
        this.isTestimonialAvailable = this.isViewAble(testimonial);
      }
    }
    for (const brochure of profile.details.brochures) {
      if (!this.isBrochureAvailable) {
        this.isBrochureAvailable = this.isViewAble(brochure);
      }
    }
    for (const screenShot of profile.details.screenshots) {
      if (!this.isScreenShotAvailable) {
        this.isScreenShotAvailable = this.isViewAble(screenShot);
      }
    }

    for (const video of profile.details.videos) {
      if (!this.isVideoAvailable) {
        this.isVideoAvailable = this.isViewAble(video);
      }
    }

    for (const award of profile.details.awards) {
      if (!this.isAwardAvailable) {
        this.isAwardAvailable = this.isViewAble(award);
      }
    }
  }

  retailCommission() {
    this.retailCom = true;
  }

  parseLinks(inputText: string) {
    let replacedText, replacePattern1, replacePattern2, replacePattern3;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    //Change email addresses to mailto:: links.
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

    return replacedText;
  }

  buyProduct(item: any, index) {
    this.sharedService.setData('selectedProfile', this.profile);
    this.router.navigateByUrl('/onebill-checkout?profileId=' + this.sharedService.encodeBase64(this.profile.id) + '&planId=' + item.planId);
  }

  gotoProductRFQ() {
    if (this.isBuyer() || !this.isLoggedIn()) {
      this.sharedService.setParameter('selectedProfile', this.profile);
      this.router.navigateByUrl('/buyer/?profileId=' + this.sharedService.encodeBase64(this.profile.id));
    } else if (this.isReseller()) {
      AlertMessageComponent.open(AlertType.Error, 'Reseller can perform RFQ process from Dashboard');
    } else if (this.isVendor()) {
      AlertMessageComponent.open(AlertType.Error, 'You need to logged in as a buyer to request quote');
    }
  }

  gotoRFQ(item: any, index) {
    if (this.isBuyer() || !this.isLoggedIn()) {
      this.sharedService.setParameter('selectedProfile', this.profile);
      this.sharedService.setParameter('isPricingAvailable', this.isPricingDisplay(item));
      this.router.navigateByUrl('/request-for-quotation?profileId=' + this.sharedService.encodeBase64(this.profile.id) + '&planId=' + item.planId);
    } else if (this.isReseller()) {
      AlertMessageComponent.open(AlertType.Error, 'Reseller can perform RFQ process from Dashboard');
    } else if (this.isVendor()) {
      AlertMessageComponent.open(AlertType.Error, 'You need to logged in as a buyer to request quote');
    }
  }

  scrollTop() {
    window.scrollTo(0, 0);
  }


  confirmAddToCatalog() {
    this.errorMessage = '';
    let data: any = {resellerPrograms: []};
    for (var key in this.resellerProgram) {
      if (this.resellerProgram.hasOwnProperty(key)) {
        if (this.resellerProgram[key] === true) {
          data.resellerPrograms.push(key);
          this.resellerProgram[key] = false;
        }
      }
    }

    this.api.put(this.endpoints.getRequestAppApprovalUrl() + '?appProfileId=' + this.profile.id, data, true)
      .subscribe(response => {
          console.log(response)

          if (response.message == 'NO_ADDITIONAL_TERMS' && response.resellerProgramApprovalStatus == 'APPROVED') {
            this.successMessage = 'Add successfully to your catalog';
            console.log(this.successMessage)
          } else if (response.message == 'NO_ADDITIONAL_TERMS' && response.resellerProgramApprovalStatus == 'NON-APPROVED') {
            this.successMessage = 'Request for SaasMax approval has been sent!';
          }

          if (response.message == 'ADDITIONAL_TERMS' && response.resellerProgramApprovalStatus == 'NON-APPROVED') {
            this.successMessage = 'Request for SaasMax approval has been sent!';
          }

          if (response.message == 'ADDITIONAL_TERMS' && response.resellerProgramApprovalStatus == 'APPROVED' || (response.message == 'ADDITIONAL_TERMS_AND_APPROVAL' && response.resellerProgramApprovalStatus == 'APPROVED')) {
            this.eSignUrl = response.partyOneContactUrl
            this.trustedESignUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.eSignUrl);
            this.showForm = true;

          }

          if (response.message == 'ADDITIONAL_TERMS_AND_APPROVAL' && response.resellerProgramApprovalStatus == 'NON-APPROVED') {
            this.successMessage = 'Request for approval has been sent!';
          }
          this.approvalRequested = true;
          this.getResellerProgramStatus(this.profile.id)
        },
        error => {
          this.errorMessage = JSON.parse(error._body).message;
        });
    return false;
  }

  done() {
    this.showForm = false;
    this.eSignUrl = '';
    this.affiliateContractUrl = '';
    this.retailCommissionContractUrl = '';
    this.whiteLabelContractUrl = '';
    this.wholesaleCommissionContractUrl = '';
    this.hideModal();
  }

  addToFavorites() {
    this.api.post(this.endpoints.getBookmarkUrl() + '?profileId=' + this.profile.id, null, true)
      .subscribe(response => {
        this.isAddedToFavorites = true;
      });
  }

  removeFromFavorites() {
    this.api.delete(this.endpoints.getBookmarkUrl(this.profile.id))
      .subscribe(response => {
        this.isAddedToFavorites = false;
      });
  }

  public showModal(): void {

    this.modal.config.backdrop = true;
    this.modal.show();
  }

  public hideModal(): void {
    this.modal.hide();
    //  this.modal.ngOnDestroy();
  }

  public showResellerAlertModal(): void {
    if (!this.isReseller() && !this.isVendorOwnProduct()) {
      this.resellerAlertModal.config.backdrop = false;
      this.resellerAlertModal.show();
    }
  }

  public showSupportModal(): void {
    if (this.isBuyer() || this.isVendorOwnProduct()) {
      this.supportModel.config.backdrop = false;
      this.supportModel.show();
    }
  }

  public hideSupportModal(): void {
    this.supportModel.hide();
  }

  public showResellerProgramModal(): void {
    if (this.isReseller() || this.isVendorOwnProduct()) {
      this.resellerProgramModal.config.backdrop = false;
      this.resellerProgramModal.show();
      this.showResellerProgram = true;
    }
  }
  public showTooltipModal(sub: any): void {
      this.subject = sub;
      this.tooltipModal.config.backdrop = false;
      this.tooltipModal.show();
  }
  public hidetooltipModal(): void {
    this.tooltipModal.hide();
  }

  public showResellerVideoModal(): void {
    this.resellerVideoModal.config.backdrop = false;
    this.resellerVideoModal.show();
    this.showResellerVideo = true;
  }

  public hideResellerVideoModal(): void {
    this.resellerVideoModal.hide();
    this.showResellerVideo = false;
  }

  setDefaultLogoUrl(profile) {
    setTimeout(() => {
      if (profile && !profile.logoUrl) {
        profile.logoUrl = '/assets/img/default-app-logo.png';
      }
    }, 1000);
  }

  isLoggedIn() {
    return this.userService.isLoggedIn();
  }

  isReseller() {
    return this.userService.isReseller();
  }

  isBuyer() {
    return this.userService.isBuyer();
  }

  joinObjectList(list: Array<any>, property: string, delimeter: string): string {
    return list.map((item) => item[property]).join(delimeter);
  }

  private setShareUrl() {
    this.shareUrl = `https://platform.twitter.com/widgets/tweet_button.5c39137502ea1894df4434ae5ed041c5.en.html#dnt=false&id=twitter-widget-6&lang=en&original_referer=type=${window.location.href}&size=m&text=${this.profile.name}%20-%20SaaSMAX&time=1493635561941`
  }

  isPricingAvailable(profile) {
    if (profile.details) {
      return (profile.details.pricingPlans.length > 0) ? true : false;
    }
    return false;
  }

  isSuperAdmin() {
    return this.userService.isSuperAdmin();
  }

  isVendor() {
    return this.userService.isVendor();
  }

  safeURL(videoUrl: string) {
    videoUrl = videoUrl.replace('watch?v=', 'embed/');
    videoUrl = videoUrl.replace('/youtu.be/', '/youtube.com/embed/');
    videoUrl = videoUrl.replace('/vimeo.com/', '/player.vimeo.com/video/');
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoUrl);
  }

  getResellerProgramStatus(profileId) {
    this.api.get(this.endpoints.getResellerProgramRequestStatus() + '?profileId=' + profileId, true)
      .subscribe(response => {
        this.resellerProgramRequestList = response;
        if (response['retailCommissionStatus']) {
          this.getRetailCommissionStatus(response['retailCommissionStatus']);
        }
        if (response['wholesaleCommissionStatus']) {
          this.WholesaleCommissionStatus(response['wholesaleCommissionStatus']);
        }
        if (response['affiliateStatus']) {
          this.getAffiliateStatus(response['affiliateStatus']);
        }
        if (response['whiteLabelStatus']) {
          this.getWhiteLabelStatus(response['whiteLabelStatus']);
        }

      });

  }

  getRetailCommissionStatus(value) {
    if (value == 'NONE') {
      this.retailCommissionStatus = 'Not Requested'
      this.isRetailDistable = false;
    } else if (value == 'APPROVED') {
      this.retailCommissionStatus = 'Approved'
      this.isRetailDistable = true;
    } else if (value == 'PENDING') {
      this.retailCommissionStatus = 'Pending Approval'
      this.isRetailDistable = true;
    } else if (value == 'IN_PROGRESS') {
      this.retailCommissionStatus = 'Pending Vendor Approval'
      this.isRetailDistable = true;
    } else if (value == 'REJECTED') {
      this.retailCommissionStatus = 'Rejected'
      this.isRetailDistable = false;
    } else if (value == 'REQUEST_APPROVED') {
      this.retailCommissionStatus = 'SaaSMAX Approved'
      this.isRetailDistable = false;
    } else if (value == 'SIGNED') {
      this.retailCommissionStatus = 'Pending Vendor Signature'
      this.isRetailDistable = true;
    }
  }

  WholesaleCommissionStatus(value) {
    if (value == 'NONE') {
      this.wholesaleCommissionStatus = 'Not Requested';
      this.isWholesaleDisable = false;
    } else if (value == 'APPROVED') {
      this.wholesaleCommissionStatus = 'Approved';
      this.isWholesaleDisable = true;
    } else if (value == 'PENDING') {
      this.wholesaleCommissionStatus = 'Pending Approval';
      this.isWholesaleDisable = true;
    } else if (value == 'IN_PROGRESS') {
      this.wholesaleCommissionStatus = 'Pending Vendor Approval';
      this.isWholesaleDisable = true;
    } else if (value == 'REJECTED') {
      this.wholesaleCommissionStatus = 'Rejected';
      this.isWholesaleDisable = false;
    } else if (value == 'REQUEST_APPROVED') {
      this.wholesaleCommissionStatus = 'SaaSMAX Approved';
      this.isWholesaleDisable = false;
    } else if (value == 'SIGNED') {
      this.wholesaleCommissionStatus = 'Pending Vendor Signature';
      this.isWholesaleDisable = true;
    }
  }

  getAffiliateStatus(value) {
    if (value == 'NONE') {
      this.affiliateStatus = 'Not Requested'
      this.isAffiliateDisable = false;
    } else if (value == 'APPROVED') {
      this.affiliateStatus = 'Approved'
      this.isAffiliateDisable = true;
    } else if (value == 'PENDING') {
      this.affiliateStatus = 'Pending Approval'
      this.isAffiliateDisable = true;
    } else if (value == 'IN_PROGRESS') {
      this.affiliateStatus = 'Pending Vendor Approval'
      this.isAffiliateDisable = true;
    } else if (value == 'REJECTED') {
      this.affiliateStatus = 'Rejected'
      this.isAffiliateDisable = false;
    } else if (value == 'REQUEST_APPROVED') {
      this.affiliateStatus = 'SaaSMAX Approved'
      this.isAffiliateDisable = false;
    } else if (value == 'SIGNED') {
      this.affiliateStatus = 'Pending Vendor Signature'
      this.isAffiliateDisable = true;
    }
  }

  getWhiteLabelStatus(value) {
    if (value == 'NONE') {
      this.whiteLabelStatus = 'Not Requested'
      this.isWhitelabelDisable = false;
    } else if (value == 'APPROVED') {
      this.whiteLabelStatus = 'Approved'
      this.isWhitelabelDisable = true;
    } else if (value == 'PENDING') {
      this.whiteLabelStatus = 'Pending Approval'
      this.isWhitelabelDisable = true;
    } else if (value == 'IN_PROGRESS') {
      this.whiteLabelStatus = 'Pending Vendor Approval'
      this.isWhitelabelDisable = true;
    } else if (value == 'REJECTED') {
      this.whiteLabelStatus = 'Rejected'
      this.isWhitelabelDisable = false;
    } else if (value == 'REQUEST_APPROVED') {
      this.whiteLabelStatus = 'SaaSMAX Approved'
      this.isWhitelabelDisable = false;
    } else if (value == 'SIGNED') {
      this.whiteLabelStatus = 'Pending Vendor Signature'
      this.isWhitelabelDisable = true;
    }

  }


  getResellerProgramType() {
    if (this.profile.details.availableResellerProgram['Affiliate-participationCriteria'] == 'NO_ADDITIONAL_TERMS') {
      this.affiliateType = 'No Contract';
    } else if (this.profile.details.availableResellerProgram['Affiliate-participationCriteria'] == 'ADDITIONAL_TERMS') {
      this.affiliateType = 'Contract Required';
      this.affiliateTemplateId = this.profile.details.availableResellerProgram['Affiliate-templateId'];
    } else if (this.profile.details.availableResellerProgram['Affiliate-participationCriteria'] == 'ADDITIONAL_TERMS_AND_APPROVAL') {
      this.affiliateType = 'Approval & Contract Required';
      this.affiliateTemplateId = this.profile.details.availableResellerProgram['Affiliate-templateId'];
    }

    if (this.profile.details.availableResellerProgram['RetailCommission-participationCriteria'] == 'NO_ADDITIONAL_TERMS') {
      this.retailCommissionType = 'No Contract';
    } else if (this.profile.details.availableResellerProgram['RetailCommission-participationCriteria'] == 'ADDITIONAL_TERMS') {
      this.retailCommissionType = 'Contract Required';
      this.retailCommissionTemplateId = this.profile.details.availableResellerProgram['RetailCommission-templateId']
    } else if (this.profile.details.availableResellerProgram['RetailCommission-participationCriteria'] == 'ADDITIONAL_TERMS_AND_APPROVAL') {
      this.retailCommissionType = 'Approval & Contract Required';
      this.retailCommissionTemplateId = this.profile.details.availableResellerProgram['RetailCommission-templateId'];
    }

    if (this.profile.details.availableResellerProgram['WhiteLabel-participationCriteria'] == 'NO_ADDITIONAL_TERMS') {
      this.whiteLabelType = 'No Contract';
    } else if (this.profile.details.availableResellerProgram['WhiteLabel-participationCriteria'] == 'ADDITIONAL_TERMS') {
      this.whiteLabelType = 'Contract Required';
      this.whiteLabelTemplateId = this.profile.details.availableResellerProgram['WhiteLabel-templateId'];
    } else if (this.profile.details.availableResellerProgram['WhiteLabel-participationCriteria'] == 'ADDITIONAL_TERMS_AND_APPROVAL') {
      this.whiteLabelType = 'Approval & Contract Required';
      this.whiteLabelTemplateId = this.profile.details.availableResellerProgram['WhiteLabel-templateId'];
    }

    if (this.profile.details.availableResellerProgram['WholeSaleCommission-participationCriteria'] == 'NO_ADDITIONAL_TERMS') {
      this.wholesaleCommissionType = 'No Contract';
    } else if (this.profile.details.availableResellerProgram['WholeSaleCommission-participationCriteria'] == 'ADDITIONAL_TERMS') {
      this.wholesaleCommissionType = 'Contract Required';
      this.wholesaleCommissionTemplateId = this.profile.details.availableResellerProgram['WholeSaleCommission-templateId'];
    } else if (this.profile.details.availableResellerProgram['WholeSaleCommission-participationCriteria'] == 'ADDITIONAL_TERMS_AND_APPROVAL') {
      this.wholesaleCommissionType = 'Approval & Contract Required';
      this.wholesaleCommissionTemplateId = this.profile.details.availableResellerProgram['WholeSaleCommission-templateId'];
    }
  }

  viewContract(value) {
    if (value == 'retailCommission') {
      this.retailCommissionContractUrl = this.getSignedDoc(value) ? this.getSignedDoc(value) : this.profile.details.availableResellerProgram['RetailCommission-contractDocUrl'];
      this.wholesaleCommissionContractUrl = '';
      this.affiliateContractUrl = '';
      this.whiteLabelContractUrl = '';
      this.trustedRetailCommissionContractUrl = this.safeContractUrl(this.retailCommissionContractUrl);
    } else if (value == 'wholesaleCommission') {
      this.retailCommissionContractUrl = '';
      this.wholesaleCommissionContractUrl = this.getSignedDoc(value) ? this.getSignedDoc(value) :  this.profile.details.availableResellerProgram['WholeSaleCommission-contractDocUrl'];
      this.affiliateContractUrl = '';
      this.whiteLabelContractUrl = '';
      this.trustedWholesaleCommissionContractUrl = this.safeContractUrl(this.wholesaleCommissionContractUrl);
    } else if (value == 'affiliate') {
      this.retailCommissionContractUrl = '';
      this.wholesaleCommissionContractUrl = '';
      this.affiliateContractUrl = this.getSignedDoc(value) ? this.getSignedDoc(value) :  this.profile.details.availableResellerProgram['Affiliate-contractDocUrl'];
      this.whiteLabelContractUrl = '';
      this.trustedAffiliateContractUrl = this.safeContractUrl(this.affiliateContractUrl);
    } else if (value == 'whiteLabel') {
      this.retailCommissionContractUrl = '';
      this.wholesaleCommissionContractUrl = '';
      this.affiliateContractUrl = '';
      this.whiteLabelContractUrl = this.getSignedDoc(value) ? this.getSignedDoc(value) :  this.profile.details.availableResellerProgram['WhiteLabe-contractDocUrl'];
      this.trustedWhiteLabelContractUrl = this.safeContractUrl(this.whiteLabelContractUrl);
    }

    this.showForm = true;
  }

  getSignedDoc(value) {
    return this.resellerProgramRequestList[value + '-signedContract'] ? this.resellerProgramRequestList[value + '-signedContract'] : null;
  }

  safeContractUrl(value) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  back() {
    this.showForm = false;
    this.eSignUrl = '';
    this.affiliateContractUrl = '';
    this.retailCommissionContractUrl = '';
    this.whiteLabelContractUrl = '';
    this.wholesaleCommissionContractUrl = '';
  }

  checkResellerCompany(value) {
    if (value == 'retailCommission') {
      for (let i = 0; i < this.profile.details.resellerProgram.retailCommission.commissionTiers.length; i++) {
        for (let j = 0; j < this.profile.details.resellerProgram.retailCommission.commissionTiers[i].resellerCompanies.length; j++) {
          if (this.currentUser.orgId == this.profile.details.resellerProgram.retailCommission.commissionTiers[i].resellerCompanies[j] &&
            this.profile.details.resellerProgram.retailCommission.commissionTiers[i].status == 'PUBLISHED') {
            return true;
          }
        }
        if (this.profile.details.resellerProgram.retailCommission.commissionTiers[i].isTierForAllResellers &&
          this.profile.details.resellerProgram.retailCommission.commissionTiers[i].status == 'PUBLISHED') {
          return true;
        }
      }
    } else if (value == 'wholesaleCommission') {
      for (let i = 0; i < this.profile.details.resellerProgram.wholesaleCommission.commissionTiers.length; i++) {
        for (let j = 0; j < this.profile.details.resellerProgram.wholesaleCommission.commissionTiers[i].resellerCompanies.length; j++) {
          if (this.currentUser.orgId == this.profile.details.resellerProgram.wholesaleCommission.commissionTiers[i].resellerCompanies[j] &&
            this.profile.details.resellerProgram.wholesaleCommission.commissionTiers[i].status == 'PUBLISHED') {
            return true;
          }
        }
        if (this.profile.details.resellerProgram.wholesaleCommission.commissionTiers[i].isTierForAllResellers &&
          this.profile.details.resellerProgram.wholesaleCommission.commissionTiers[i].status == 'PUBLISHED') {
          return true;
        }
      }
    } else if (value == 'affiliate') {
      for (let i = 0; i < this.profile.details.resellerProgram.affiliate.commissionTiers.length; i++) {
        for (let j = 0; j < this.profile.details.resellerProgram.affiliate.commissionTiers[i].resellerCompanies.length; j++) {
          if (this.currentUser.orgId == this.profile.details.resellerProgram.affiliate.commissionTiers[i].resellerCompanies[j] &&
            this.profile.details.resellerProgram.affiliate.commissionTiers[i].status == 'PUBLISHED') {
            return true;
          }
        }
        if (this.profile.details.resellerProgram.affiliate.commissionTiers[i].isTierForAllResellers &&
          this.profile.details.resellerProgram.affiliate.commissionTiers[i].status == 'PUBLISHED') {
          return true;
        }
      }
    } else if (value == 'whiteLabel') {
      for (let i = 0; i < this.profile.details.resellerProgram.whiteLabel.commissionTiers.length; i++) {
        for (let j = 0; j < this.profile.details.resellerProgram.whiteLabel.commissionTiers[i].resellerCompanies.length; j++) {
          if (this.currentUser.orgId == this.profile.details.resellerProgram.whiteLabel.commissionTiers[i].resellerCompanies[j] &&
            this.profile.details.resellerProgram.whiteLabel.commissionTiers[i].status == 'PUBLISHED') {
            return true;
          }
        }
        if (this.profile.details.resellerProgram.whiteLabel.commissionTiers[i].isTierForAllResellers &&
          this.profile.details.resellerProgram.whiteLabel.commissionTiers[i].status == 'PUBLISHED') {
          return true;
        }
      }
    }
    return false;
  }

  getCurrentUser() {
    if (this.isLoggedIn()) {
      this.userService.getCurrentUser()
        .then(user => {
          this.currentUser = user;
        });
    }
  }

  isLoggedInVendorProduct() {
    if (this.isVendor()) {
      return this.profile.appVendor.id === this.currentUser.orgId ? true : false;
    } else if (!this.isBuyer() && this.isLoggedIn()) {
      return true;
    } else {
      return false;
    }
  }

  isViewContract(value) {
    if (value == 'retailCommission') {
      if (this.profile.details.availableResellerProgram['RetailCommission-contractDocUrl'])
        return true;
    } else if (value == 'wholesaleCommission') {
      if (this.profile.details.availableResellerProgram['WholeSaleCommission-contractDocUrl'])
        return true;
    } else if (value == 'affiliate') {
      if (this.profile.details.availableResellerProgram['Affiliate-contractDocUrl'])
        return true;
    } else if (value == 'whiteLabel') {
      if (this.profile.details.availableResellerProgram['WhiteLabel-contractDocUrl'])
        return true;
    }
    return false;
  }

  viewAllDesc() {
    this.textMaxLenght = this.textMaxLenght === 1500 ? 230 : 1500;
  }

  viewAll1() {
    this.textMaxLenght1 = this.textMaxLenght1 === 10000 ? 230 : 10000;
  }

  viewAll2() {
    this.textMaxLenght2 = this.textMaxLenght2 === 10000 ? 230 : 10000;
  }

  viewAll3() {
    this.textMaxLenght3 = this.textMaxLenght3 === 10000 ? 230 : 10000;
  }

  viewAll4() {
    this.textMaxLenght4 = this.textMaxLenght4 === 10000 ? 230 : 10000;
  }

  viewAll5() {
    this.textMaxLenght5 = this.textMaxLenght5 === 10000 ? 230 : 10000;
  }

  viewAll6() {
    this.textMaxLenght6 = this.textMaxLenght6 === 10000 ? 230 : 10000;
  }

  viewAll7() {
    this.textMaxLenght7 = this.textMaxLenght7 === 10000 ? 230 : 10000;
  }

  viewAll8() {
    this.textMaxLenght8 = this.textMaxLenght8 === 10000 ? 230 : 10000;
  }

  isViewAble(brochure) {
    if (this.isVendorOwnProduct()) {
      return true;
    } else if (brochure.organizationType) {
      if (this.isLoggedIn()) {
        if ((brochure.organizationType == 'PUBLIC')) {
          return true;
        } else if (brochure.organizationType == 'BUYER' && this.isLoggedIn()) {
          return true;
        } else if ((brochure.organizationType == 'RESELLER' || brochure.organizationType == 'NONE') && this.isVendor()) {
          return this.profile.appVendor.id === this.currentUser.orgId ? true : false;
        } else if ((brochure.organizationType == 'RESELLER' && this.isReseller())) {
          return this.isApprovedReseller;
        } else if (this.isSuperAdmin()) {
          return true;
        }
      } else if (brochure.organizationType == 'PUBLIC') {
        return true;
      }
    } else {
      return false;
    }
  }

  isPricingDisplay(pricingPlan) {
    if (pricingPlan.publicDisplay != 'RFQ_NO_PRICING') {
      this.isPricingAmountAvailable = true;
    } else if (pricingPlan.registeredBuyerDisplay != 'RFQ_NO_PRICING' && this.isLoggedIn()) {
      this.isPricingAmountAvailable = true;
    } else if (pricingPlan.registeredResellerDisplay != 'RFQ_NO_PRICING' && this.isLoggedIn()) {
      if ((this.isVendor() && this.profile.appVendor.id === this.currentUser.orgId) || this.isReseller() || this.isSuperAdmin()) {
        this.isPricingAmountAvailable = true;
      }
    } else if (this.isSuperAdmin()) {
      this.isPricingAmountAvailable = true;
    } else {
      return false;
    }
    return this.isPricingAmountAvailable;
  }

  isVendorOwnProduct() {
    if (this.isSuperAdmin() || (this.isVendor() && this.profile.appVendor.id === this.currentUser.orgId)) {
      return true;
    }
    return false;
  }

  getSelectedResellerProgramStatus() {
    if (this.selectedResellerOption == 'Retail') {
      return this.retailCommissionStatus;
    } else if (this.selectedResellerOption == 'Wholesale') {
      return this.wholesaleCommissionStatus;
    } else if (this.selectedResellerOption == 'WhiteLabel') {
      return this.whiteLabelStatus;
    } else if (this.selectedResellerOption == 'Affiliate') {
      return this.affiliateStatus;
    }
  }

  isProfileLoaded() {
    return this.profile.appVendor ? true : false;
  }

  requestMeetingResponse() {
    this.requestMeeting = '';
  }

}




// WEBPACK FOOTER //
// ./src/app/components/app-profile/app-profile.component.ts